/**
 *
 */
import O1HD from "../../../../../engines/gameEngine";
import {RegisterSpecialEventEntity, RegisterSpecialEventEntityCopy} from "../../../manager/NormalGameManager";
import {EventParamsTypeConstant} from "../../const/EventParamsTypeConstant";

const {ccclass, property} = cc._decorator;

/**
 * 算命大师
 */
@ccclass
export default class FortuneTelling extends cc.Component {

    @property(cc.Node)
    step1Node : cc.Node = null;
    @property(cc.Node)
    step2Node : cc.Node = null;
    @property(cc.Node)
    dialogNode : cc.Node = null;
    @property(cc.Label)
    lbDesc : cc.Label = null;
    @property(cc.Node)
    resultPageNode : cc.Node = null;
    @property(cc.Prefab)
    forecastGame : cc.Prefab = null;

    private mChooseOne : string ;
    private chooseJson : string[][] = [
        [
            "天上下雨地上滑、你爸姓啥你姓啥",
            "出门打车你得叫出租，你爸的姐是不是得叫一声大姑?",
            "人吃粮食羊吃草，你的年龄肯定比你爹小，我说的对吗？",
            "吃饭你得做，睡觉你得躺，你爸和你妈结婚你肯定没在场，对不对！",
            "出门你得穿鞋，你奶奶的老公你是不是得叫声爷",
            "鱼配鱼，虾配虾，乌龟是不是配王八？",
            "太阳出来照西边，你爸和你妈结婚在同一天我没算错吧？",
        ],
    ];
    private chooseEntity : string[] = null;
    private mContent : string;
    private mChooseIndex : number = 0;

    onLoad () {}

    start () {
        this.chooseEntity = this.chooseJson[Math.floor( Math.random()*this.chooseJson.length )];
        this.mContent = this.chooseEntity[this.mChooseIndex];
        this.lbDesc.string = "";
        this.showContent();
    }

    /**
     * 步骤1 选择
     */
    onBtnStepOneChoose( e , chooseDefine : string ){
        this.mChooseOne = chooseDefine;
        if ( chooseDefine == "1" ) {
            // let imgSpecialEventArray : RegisterSpecialEventEntityCopy[] = [];
            // let itemEntity : RegisterSpecialEventEntityCopy = null;
            // itemEntity = {
            //     startHours : 0,//不用管
            //     waitHours : 0,//不用管
            //     type : 2,//固定值
            //     effectParams : [],
            //     desc : `我知道你很急，但是你先别急，信不信我把你喜欢的人名字算出来？`,
            //     chooseArray:[
            //         {chooseItemName:"我信",desc:"",effectParams:[],clickFun:()=>{
            //                 return new Promise<void>(resolve=>{
            //                     let forecastGamePrefab = cc.instantiate( this.forecastGame );
            //                     O1HD.Canvas().addChild( forecastGamePrefab );
            //                     this.node.removeFromParent();
            //                     this.node.destroy();
            //                     resolve();
            //                 });
            //             },isHasNext:false},
            //         {chooseItemName:"我不信",desc:"",effectParams:[],clickFun:()=>{
            //                 return new Promise<void>(resolve=>{
            //                     //
            //                     let specialEventArray : RegisterSpecialEventEntity[] = [];
            //                     let itemEntity : RegisterSpecialEventEntity = {
            //                         startHours : 0,
            //                         waitHours : 0,
            //                         type : 1,
            //                         desc : `错过我会让你损失一千万`,
            //                         effectParams : [
            //                             { key : EventParamsTypeConstant.MOOD , value : -10 },
            //                         ]
            //                     };
            //                     specialEventArray.push(itemEntity);
            //                     O1HD.emit("normalMode.setSpecialEventShow", specialEventArray );
            //                     this.node.removeFromParent();
            //                     this.node.destroy();
            //                     resolve();
            //                 });
            //             },isHasNext:false}
            //     ],
            //     isNext:false
            // };
            // imgSpecialEventArray.push(itemEntity);
            // O1HD.emit("normalMode.setSpecialEventShow",itemEntity);
            this.node.getChildByName("forecastNode").active = true;
        }else{
            this.step2Node.active = true;
        }
        this.node.getChildByName("btnStep1Back").active = false;
    }

    /**
     *
     * @param e
     * @param chooseDefine
     */
    onBtnForecastChoose( e , chooseDefine ){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if ( chooseDefine == "1" ){
            let specialEventArray : RegisterSpecialEventEntity[] = [];
            let itemEntity : RegisterSpecialEventEntity = {
                startHours : 0,
                waitHours : 0,
                type : 1,
                desc : `错过我会让你损失一千万`,
                effectParams : [
                    { key : EventParamsTypeConstant.MOOD , value : -10 },
                ]
            };
            specialEventArray.push(itemEntity);
            O1HD.emit("normalMode.setSpecialEventShow", specialEventArray );
            this.node.removeFromParent();
            this.node.destroy();
        }else{
            let forecastGamePrefab = cc.instantiate( this.forecastGame );
            O1HD.Canvas().addChild( forecastGamePrefab );
            this.node.removeFromParent();
            this.node.destroy();
        }
    }

    /**
     * 选项
     * @param e
     * @param chooseType
     */
    onBtnChooseOption( e , chooseType : string ){
        if ( this.mChooseIndex == this.chooseEntity.length - 1 ) {
            //结果页面
            O1HD.getServices().userSrv.setMood( 10 ,true );
            O1HD.getServices().userSrv.setCoins( -10 , true );
            this.resultPageNode.active = true;
            this.step2Node.active = false;
            return;
        }
        switch ( chooseType ) {
            case "1":
                //老神棍
                O1HD.getManagers().soundMgr.playSound("lsp").then();
                break;
            case "2":
                //打赏一缘
                O1HD.getServices().userSrv.setCoins( -1 , true , e.target );
                break;
            case "3":
                //说对了
                let flowerNode = cc.instantiate( this.node.getChildByName("step2Node").getChildByName("flowerNode") );
                flowerNode.active = true;
                this.node.addChild( flowerNode );
                cc.tween( flowerNode )
                    .to(1,{x:0,y:230})
                    .call(()=>{
                        flowerNode.active = false;
                    })
                    .start();
                break;
        }
        this.mContent = this.chooseEntity[++this.mChooseIndex];
        this.lbDesc.string = "";
        this.showContent();
    }

    /**
     * 返回
     */
    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.node.removeFromParent();
        this.node.destroy();
    }

    /**
     * 确定
     */
    onBtnMakeSure(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.node.removeFromParent();
        this.node.destroy();
    }

    /**
     * 展示内容
     */
    showContent(){
        if ( this.lbDesc.string.length == this.mContent.length ) {
            return;
        }
        this.lbDesc.string = this.mContent.substr( 0 , this.lbDesc.string.length + 1 );
        this.scheduleOnce(()=>{
            this.showContent();
        },0.1);
    }

}
